import { render } from "./CustomerDetailsModal.vue?vue&type=template&id=0feeeb2a"
import script from "./CustomerDetailsModal.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__